import { render } from "./productItem.vue?vue&type=template&id=2fdb14fe&scoped=true"
import script from "./productItem.vue?vue&type=script&lang=js"
export * from "./productItem.vue?vue&type=script&lang=js"

import "./productItem.vue?vue&type=style&index=0&id=2fdb14fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdb14fe"]])

export default __exports__